
export enum NotificationSeverity {
    Info,
    Success,
    Warning,
    Danger
}

export interface INotificationEditorModel {
    severity: string;
    message: string;
}


export class NotificationModel {
    message: string;
    severity: NotificationSeverity;

    constructor(message: string, severity: NotificationSeverity) {
        this.message = message;
        this.severity = severity;
    }
}

class ExportCommandLogModel {
    modelId: string;
    entryIds: string[];

    constructor(modelId: string, entryIds: string[]) {
        this.modelId = modelId;
        this.entryIds = entryIds;
    }
}

// Command log Api services
export class NotificationApiServices {


    // Creates a site down notification
    createSiteDownNotification(message: string): Promise<any> {
        const model = new NotificationModel(message, NotificationSeverity.Warning);

        return $.post("/api/1.0/notifications/sitedown", model);
    }

    // Creates a user notification
    createNotification(message: string, severity: NotificationSeverity): Promise<any> {

        const model = new NotificationModel(message, severity);

        return $.post("/api/1.0/notifications", model);
    }

    // Clears all notifications
    clearNotifications(): Promise<any> {


        return $.post("/api/1.0/notifications/clear");
    }

}


// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.notification-services.ts